import { defineComponent as _defineComponent } from 'vue'
import { useElementSize } from '@vueuse/core'
import { inject, ref, watch } from 'vue'
import AppButtonIcon from '../button/AppButtonIcon.vue'
import AppIcon from '../icon/AppIcon.vue'
import { ModalInjectionKey } from './injection-key'


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalHeader',
  props: {
  title: null,
  hideClose: { type: Boolean }
},
  setup(__props) {

const el = ref<HTMLDivElement>()
const { height } = useElementSize(el, undefined, { box: 'border-box' })



const { close, updateHeaderHeight } = inject(ModalInjectionKey)!

watch(height, (val) => {
  updateHeaderHeight(val)
})

return { __sfc: true,el, height, close, updateHeaderHeight, AppButtonIcon, AppIcon }
}

})